
function getCurrentYear() {
  return new Date().getFullYear();
}

function getCurrentWeekDates() {
    const today = new Date();

    const monday = new Date(today);
    const dayOfWeek = monday.getDay(); // Sunday is 0, Saturday is 6
    const daysToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
    monday.setDate(monday.getDate() + daysToMonday);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return [
      monday,
      sunday
    ];
}

// A Date whose LOCAL getters read America/New_York wall-clock time. All spend
// data is keyed to New York civil dates, so date-window anchors must use this
// instead of new Date() or viewers outside US Eastern get shifted windows
// (e.g. June pacing shown in July from a UTC+ timezone).
function getNewYorkNow() {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false,
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type)?.value);
    return new Date(
        get('year'), get('month') - 1, get('day'),
        get('hour') % 24, get('minute'), get('second')
    );
}

function getCurrentMonthDates() {
    const today = getNewYorkNow();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    return [
        firstOfMonth,
        today
    ];
}

function getLastSixMonthsRange() {
    const endDate = new Date();
    const startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 5, 1);

    return [startDate, endDate];
}

function formatDateToYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export { getCurrentYear, getCurrentWeekDates, getCurrentMonthDates, getLastSixMonthsRange, formatDateToYMD, getNewYorkNow };
